import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as style from "./styles.module.scss";
import { yotiFetchIframeUrl } from "../../redux/actions";

const YotiIframe = ({ iframeUrl, fetchIframeUrl, jobId, findStep }) => {
  useEffect(() => {
    fetchIframeUrl(jobId);
  });

  if (!iframeUrl) {
    return <div></div>;
  }

  return (
    <Fragment>
      {iframeUrl && (
        <iframe
          src={iframeUrl}
          style={{ height: "605px", width: "100%", border: "none" }}
          allow="camera"
        ></iframe>
      )}

      <div className={`my-2 ${style.actions}`}>
        <Link to={findStep("contract-for-services", jobId)}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  iframeUrl: state.core.app.yotiIframeUrl,
});

const mapDispatchToProps = { fetchIframeUrl: yotiFetchIframeUrl };

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(YotiIframe);
